module.exports = __webpack_public_path__ + "img/80.3.TP.22906f4d.png";